/* eslint-disable jsx-a11y/label-has-associated-control */

import { ChangeEvent } from "react";

type PropsType = {
	label: string;
	value: string;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	disabled?: boolean;
	customClassnameForInput?: string;
	boldLabel?: boolean;
	error?: string;
};

const VariableField = (props: PropsType) => {
	return (
		<div className="relative flex w-full flex-col space-y-2">
			<div className="flex items-baseline justify-between gap-2">
				<label className={`md:text-md lg:text-md  text-sm font-semibold ${props.boldLabel ? " !font-bold" : ""}`}>
					{props.label}
				</label>
				{props.error && (
					<span className="text-xs text-red-500" role="alert">
						{props.error}
					</span>
				)}
			</div>
			<input
				className={`border-2 px-3 py-2 outline-none focus:ring-0 ${
					props.error ? "border-red-500" : "border-gray-300"
				} ${props.customClassnameForInput}`}
				value={props.value}
				disabled={props.disabled}
				onChange={props.onChange}
			/>
		</div>
	);
};

export default VariableField;
